/* tslint:disable */

declare var Object: any;
export interface LeaveReportServiceInterface {
  "id"?: number;
}

export class LeaveReportService implements LeaveReportServiceInterface {
  "id": number;
  constructor(data?: LeaveReportServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LeaveReportService`.
   */
  public static getModelName() {
    return "LeaveReportService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LeaveReportService for dynamic purposes.
  **/
  public static factory(data: LeaveReportServiceInterface): LeaveReportService{
    return new LeaveReportService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LeaveReportService',
      plural: 'LeaveReportServices',
      path: 'LeaveReportServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/LeaveReportService.ts